import { render } from "./PointPhotos.vue?vue&type=template&id=4055a630&scoped=true"
import script from "./PointPhotos.vue?vue&type=script&lang=js"
export * from "./PointPhotos.vue?vue&type=script&lang=js"

import "./PointPhotos.vue?vue&type=style&index=0&id=4055a630&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4055a630"]])

export default __exports__